// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReviewsCarouselSection_wrapper__BqLET","cards":"ReviewsCarouselSection_cards__Z8S92","reviews":"ReviewsCarouselSection_reviews__MFaz0"};